import { connect } from "react-redux";
import FairTr from "../Images/fair/Fair-tr.png";
import FairEn from "../Images/fair/Fair-en.png";
import { setPopupStatus } from "../store/action";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const FairModal = (props) => {
  const location = useLocation();
  
  const onCloseHandler = () => {
    props.setPopupStatus(false);
  };

  return (
    <div className="fair-modal">
      <div className="fair-modal-content">
        <div className="fair-modal-header" onClick={onCloseHandler}>
          X
        </div>
        <div className="fair-img-container">
          {location.pathname === "/" ? (
            <img
              src={FairTr}
              className="fair-img"
              alt="tms_fair_tr"
              title="tms_fair_tr"
            />
          ) : (
            <img
              src={FairEn}
              className="fair-img"
              alt="tms_fair_en"
              title="tms_fair_en"
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setPopupStatus: () => dispatch(setPopupStatus()),
});

export default connect(null, mapDispatchToProps)(FairModal);
